import { Box, Button, IconButton, Menu } from "@mui/material"
import React, { FC, ReactNode, useState } from "react"

type MenuWrapperProps = {
  children: any
  trigger?: any
  onOpen?: any
  onClose?: any
  label?: string
  menuIcon?: ReactNode
  useIconButton?: boolean
  buttonProps?: any
  menuProps?: any
  endIcon?: ReactNode
}

export const MenuWrapper: FC<MenuWrapperProps> = ({
  children,
  trigger,
  onOpen,
  onClose,
  label = "",
  menuIcon = null,
  useIconButton = false,
  buttonProps = {},
  menuProps = {},
  endIcon = null,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const openMenu = (event: any) => {
    setAnchorEl(event.currentTarget)
    if (onOpen) onOpen(event)
  }

  const closeMenu = () => {
    setAnchorEl(null)
    if (onClose) onClose()
  }

  const defaultTrigger = menuIcon || useIconButton ? (
    <IconButton
      aria-label={label}
      aria-controls={open ? "menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      onClick={openMenu}
      {...buttonProps}
    >
      {menuIcon}
    </IconButton>
  ) : (
    <Button
      aria-controls={open ? "menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      onClick={openMenu}
      {...buttonProps}
      endIcon={endIcon}
    >
      {label}
    </Button>
  )

  return (
    <Box>
      {trigger
        ? React.cloneElement(trigger, {
            onClick: openMenu,
            "aria-controls": open ? "menu" : undefined,
            "aria-haspopup": "true",
            "aria-expanded": open ? "true" : undefined,
          })
        : defaultTrigger}

      <Menu
        id="common-menu-wrapper"
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        {...menuProps}
      >
        {typeof children === "function"
          ? children(closeMenu)
          : React.Children.map(children, (child) =>
              React.cloneElement(child, {
                onClick: (e) => {
                  if (child.props.onClick) {
                    child.props.onClick(e)
                  }
                  closeMenu()
                },
              }),
            )}
      </Menu>
    </Box>
  )
}
